export enum MoscowPriority {
    MustHave = "MustHave",
    ShouldHave = "ShouldHave",
    CouldHave = "CouldHave",
    WouldHave = "WouldHave"
}

export const MoscowPriorityLabels: Record<MoscowPriority, string> = {
    [MoscowPriority.MustHave]: "Must Have",
    [MoscowPriority.ShouldHave]: "Should Have",
    [MoscowPriority.CouldHave]: "Could Have",
    [MoscowPriority.WouldHave]: "Would Have"
};

export interface ProjectRequirement {
    id: string;
    name: string;
    description?: string;
    moscowPriority?: MoscowPriority;
}